import { createContext, useContext } from "react";
var AppInsightsContext = createContext(undefined);
var useAppInsightsContext = function () { return useContext(AppInsightsContext); };
export { AppInsightsContext, useAppInsightsContext };
//# sourceMappingURL=AppInsightsContext.js.map